<template>
	
	<div class="view-content">
		<div class="view-content-info">
			<div class="user-login">
				<div class="user-login-title"><a href="/">首页</a> / <span>用户服务协议</span></div>
				<div class="user-login-content">
					<div class="agree-title">{{title}}</div>
					<div class="agree-content" v-html="content"></div>
				</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import {agreeInfo} from "@/api/login"
	export default {
		data(){
			return {
				id:0,
				title:"",
				content:""
			}
		},
		mounted() {
			this.id = this.$route.query.id || 0;
			agreeInfo({id:this.id}).then(res=>{
				if(res.code == 1000){
					this.title = res.data.title;
					this.content = res.data.content;
				}else{
					return this.$message.error(res.message);
				}
			})
		}
	}
</script>
<style scoped lang="scss">
	@import url("../assets/user.scss");
	.user-login-content{
		padding: 0px 40px;
	}
	.agree-title{
		font-size: 16px;
		font-weight: 500;
		line-height: 60px;
		color: #070B13;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		text-align: center;
	}
	.agree-content{
		font-size: 16px;
		line-height: 24px;
		color: #9E9E9E;
		padding: 24px 0px;
	}
</style>